<script lang="ts">
  import { onMount } from "svelte";

  import Window from "../components/Window.svelte";
  import SettingsMgr from "../stores/SettingsMgr";
  import type { Theme, WinCbs, WinProps } from "../scripts/WinTypes";
  import { addLog } from "../stores/LoggerStore";
  import { validate_component } from "svelte/internal";
  import MarkdownEditor from "./MarkdownEditor.svelte";
  import { random } from "../scripts/utils";
  export let winProps: WinProps;

  //Bindings ==========================================================
  let contElem: HTMLElement, ccElem: HTMLElement, theElem: HTMLCanvasElement;
  let offsetWidth, offsetHeight, innerWidth, innerHeight;
  let ctx; //init on mount
  let drawing = false;

  //Theme ============================================================
  const _theme = SettingsMgr.getInstance().theme;
  const themeWatcher = (theme: Theme) => {
    if (!contElem) {
      return;
    }
    const c = theme.colors;
    contElem.style.setProperty("color", c["1"]);
    contElem.style.setProperty("background-color", c["2"]);
    return theme.colors;
  };
  $: _colors = themeWatcher($_theme);
  //Props======================================================
  const setWinProps = () => {
    winProps.name = winProps.name || "Atelier";

    if (!winProps.data) {
      winProps.data = {};
    }
    winProps["data"]["rect"] = winProps.data?.rect || {
      top: "10%",
      left: "10%",
      width: "80%",
      height: "80%",
    };
  };
  setWinProps();
  //Window callbacks================================================

  const callbacks: WinCbs = {
    // onFocus: handleFocus,

    onMaximizeStart: () => {
      if (!theElem) {
        return false;
      }
      theElem.width = 0;
      theElem.height = 0;
      return true;
    },
    onMaximizeFinish: () => {
      if (!theElem) {
        return false;
      }
      setCanvasSize();
      return true;
    },
    // closeWindow: setCloseWindow,
    // maximizeWindow: setMaximizeWindow,
  };
  // winProps["maximizeOnMount"] = true;

  class Root {
    speedX;
    speedY;
    maxSize;
    size;
    angle;
    color;
    constructor(public x, public y, public elem = theElem) {
      this.speedX = random(-2, 2);
      this.speedY = random(-2, 2);
      this.maxSize = random(5, 12);
      this.size = random(2, 1);
      this.angle = random(6.28);
      this.color = random(360);
    }
    update() {
      this.x += this.speedX + Math.sin(this.angle);
      this.y += this.speedY + Math.sin(this.angle);
      this.size += 0.1;
      this.angle += 0.2;
      this.color += 2;
      if (this.size < this.maxSize) {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = `hsl(${this.color},100%,50%)`;
        ctx.fill();
        ctx.stroke(); //border. if stroke style not declared, default is black
        requestAnimationFrame(this.update.bind(this));
      }
    }
  }

  const setupBuildingforest = () => {
    ctx.lineWidth = 0.2;
    ctx.fillStyle = "#fff5de";
    ctx.strokeStyle = "#3c5186";
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 10;
    ctx.shadowBlur = 10;
    ctx.shadowColor = "rgba(0,0,0,0.5)";
  };
  class BuildingForest {
    speedX;
    speedY;
    maxSize;
    size;
    angleX;
    angleY;
    color;
    vs;
    vax;
    vay;
    lightness;
    angle;
    va;

    constructor(public x, public y, public elem = theElem) {
      this.speedX = random(-2, 2);
      this.speedY = random(-2, 2);
      this.maxSize = random(20, 27);
      this.size = random(2, 3);
      this.vs = random(0.5, 0.7); //size velocity
      this.angleX = random(6.28);
      this.vax = random(-0.3, 0.3);
      this.angleY = random(6.28);
      this.vay = random(-0.3, 0.3);
      this.angle = 0;
      this.va = Math.random() * 0.02 + 0.05;
      this.lightness = 10;
    }
    update() {
      this.x += this.speedX + Math.sin(this.angleX);
      this.y += this.speedY + Math.sin(this.angleY);
      this.size += this.vs;
      this.angleX += this.vax;
      this.angleY += this.vay;
      this.color += 2;
      if (this.lightness < 70) this.lightness += 0.25;
      if (this.size < this.maxSize) {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.angle);
        ctx.fillRect(0, 0, this.size, this.size);
        requestAnimationFrame(this.update.bind(this));
        ctx.restore();
      }
    }
  }

  const setup = () => {
    if (!theElem) {
      throw new Error("dd");
    }
  };

  let drawMode = "firework";

  const buildingForest = (e) => {
    const x = e.offsetX;
    const y = e.offsetY;
    // console.log(`x ${x}  y ${y}`);
    for (let i = 0; i < 5; ++i) {
      const root = new BuildingForest(x, y);
      root.update();
    }
  };

  const firework = (e) => {
    const x = e.offsetX;
    const y = e.offsetY;
    // console.log(`x ${x}  y ${y}`);
    for (let i = 0; i < 5; ++i) {
      const root = new Root(x, y);
      root.update();
    }
  };
  const handleMove = (e) => {
    if (!drawing) {
      return;
    }
    switch (drawMode) {
      case "buildingforest":
        buildingForest(e);
        return;
      case "firework":
        firework(e);
        return;
      default:
        break;
    }

    //normal draw;
    {
      ctx.beginPath();
      ctx.arc(e.offsetX, e.offsetY, 1, 0, Math.PI * 2);
      ctx.fillStyle = `hsl(0,100%,50%)`;
      ctx.fill();
    }
  };
  const setCanvasSize = () => {
    if (!ccElem) {
      return;
    }
    theElem.width = ccElem.offsetWidth;
    theElem.height = ccElem.offsetHeight;
  };
  onMount(() => {
    ctx = theElem.getContext("2d");
    setCanvasSize();
    setup();
  });
</script>

<svelte:window bind:innerWidth bind:innerHeight />

<Window {winProps} {callbacks}>
  <div class="container" bind:this={contElem}>
    <div class="tabs">
      <button
        on:click={() => {
          drawMode = "draw";
        }}
        class="draw">Just draw</button
      >
      <button
        on:click={() => {
          drawMode = "firework";
        }}
        class="firework">Fireworks</button
      >
      <button
        on:click={() => {
          drawMode = "buildingforest";
          setupBuildingforest();
        }}
        class="buildingforest">Building forest</button
      >
    </div>
    <div class="canvas-container" bind:this={ccElem}>
      <canvas
        class="the-canvas"
        on:mousemove={handleMove}
        on:mousedown={() => {
          drawing = true;
        }}
        on:mouseup={() => {
          drawing = false;
        }}
        bind:this={theElem}
      />
    </div>
    <div class="css-keeper" />
  </div></Window
>

<style>
  .container {
    position: relative;
    display: block;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  button {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .tabs {
    width: 100%;
    height: 50px;
    display: flex;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .canvas-container {
    position: relative;
    display: block;
    width: 100%;
    height: calc(100% - 50px);
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  .the-canvas {
    position: absolute;
    top: 0;
    left: 0;
    /* width: 100%; */
    /* height: 100%; */
  }
</style>
